<template>
  <div class="">

      <div class="modal fade" id="modal-edit-shipstation-order" data-backdrop="static" focus="true" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                  Edit {{ orderEdit.order_number }} (Shipstation #{{ orderEdit.shipstation_id }})
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body" v-if="!loading">
                <div class="row">
                    <!-- <div class="form-group row"> -->
                   <div class="col-md-5">
                        <label for="rep" class="col-sm-auto col-form-label fw-bold">Order Total</label>
                        <div class="col-sm-auto">
                          <span class="form-control-plaintext" id="rep">{{ orderEdit.total_cost | currency }}</span>
                        </div>
                        <!-- <label for="multiShip" class="col-sm-auto col-form-label fw-bold">Split Shipments</label>
                            <div class="col-sm-auto">
                                <span v-if="!orderEdit.multi_ship">
                                    Single &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i>
                                </span>
                                <span v-else>Split &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                            </div> -->
                           <!--  <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                        <span v-else  class="fw-bold">Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span> -->
            

                      </div>
                      <div class="col-md-5">
                        <label for="shipOne" class="col-sm-auto col-form-label fw-bold">Ship Date</label>
                        <div class="col-sm-auto">
                            <input type="date" class="form-control" id="shipOne" v-model="orderEdit.ship_one_date" :min="min_ship_date" :max="max_ship_date" @change="order_values_changed = true">
                        </div>
                        <label v-if="orderEdit.multi_ship" for="shipTwo" class="col-sm-auto col-form-label fw-bold">Ship Date Two</label>
                        <div v-if="orderEdit.multi_ship" class="col-sm-auto">
                            <input type="date" class="form-control" id="shipTwo" v-model="orderEdit.ship_two_date" :min="min_ship_date" :max="max_ship_date" @change="order_values_changed = true">
                        </div>




                        <!-- <label for="shipdateone" class="col-sm-auto col-form-label fw-bold">Close Date</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="shipdateone" v-model="orderEdit.closed_at">
                        </div>
                 
                        <label for="hubspotID" class="col-sm-auto col-form-label fw-bold">Hubspot Deal</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="hubspotID" v-model="orderEdit.hubspot_id">
                        </div>

                        <label for="hubspotStatus" class="col-sm-auto col-form-label fw-bold">Hubspot Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="hubspotStatus" v-model="orderEdit.hubspot_status">
                      </div> -->

                      </div>
                      <div class="col-md-2 align-self-end">
                        <button v-if="!add_item" type="button" class="btn btn-light text-white float-end" style="background-color:#ff7a59;" @click="addItemToggle">Add Item</button>
                        <button v-else type="button" class="btn btn-light float-end" style="border-color:#ff7a59;color:#ff7a59;" @click="addItemToggle">Cancel Item</button>
                    </div>
                    <!-- </div> -->
                    

                </div>
<!--
ITEMS
-->
                <div v-if="add_item" class="row">
                    <div v-if="fetched_products" class="card mt-2 shadow" style="border-color:#ff7a59;">
                        <div class="card-header px-0">
                            <span class="lead">Select Products</span>
                        </div>
                        <div class="card-body px-0">
                            <!-- <div class="row px-3 w-100">
                                Products
                            </div> -->
                            <div class="row justify-content-between" v-if="!product_selected">
                             
                                <div class="input-group mb-2">
                                  <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
                              
                                    <span v-if="!search_params_changed">
                                      <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
                                    
                                      <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
                                    </span>
                                    <span v-else>
                                      <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
                                    </span> &nbsp &nbsp <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                                     
                                </div>


                           
                            </div>
                            <div class="row" v-if="!product_selected">
                                <div class="col">


                                <ul class="nav justify-content-between mb-2">
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Category</span>
                                            <select v-model="pagination.searchparams.type" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option value="Apparel">Apparel</option>
                                              <option value="Bag">Bag</option>
                                              <option value="Board">Board</option>
                                              <option value="Bundle">Bundle</option>
                                              <option value="Fins">Fins</option>
                                              <option value="Rope">Rope</option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Style</span>
                                            <select v-model="pagination.searchparams.style" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option value="Compression">Compression</option>
                                              <option value="EPS">EPS</option>
                                              <option value="Garage">Garage</option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Model</span>
                                            <select v-model="pagination.searchparams.model" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option value="El Jefe">El Jefe</option>
                                              <option value="Falcon">Falcon</option>
                                              <option value="Helio">Helio</option>
                                              <option value="Hydro">Hydro</option>
                                              <option value="Lithium">Lithium</option>
                                              <option value="Mongrel">Mongrel</option>
                                              <option value="Neo">Neo</option>
                                              <option value="Nitro">Nitro</option>
                                              <!-- <option value="Nubsep">Nubsep</option> -->
                                              <option value="Nubstep">Nubstep</option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Size</span>
                                            <select v-model="pagination.searchparams.size" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option value="38">3'-8"</option>
                                              <option value="42">4'-2"</option>
                                              <option value="44">4'-4"</option>
                                              <option value="46">4'-6"</option>
                                              <option value="48">4'-8"</option>
                                              <option value="410">4'-10"</option>
                                              <option value="50">5'-0"</option>
                                              <option value="52">5'-2"</option>
                                              <option value="56">5'-6"</option>
                                              <option value="410">4'-10"</option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item mt-2">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Color</span>
                                            <select v-model="pagination.searchparams.color" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option value="Bamboo">Bamboo</option>
                                              <option value="Black">Black</option>
                                              <option value="Blue">Blue</option>
                                              <option value="Burnt">Burnt</option>
                                              <option value="Gold">Gold</option>
                                              <option value="Green">Green</option>
                                              <option value="Grey">Grey</option>
                                              <option value="Pink">Pink</option>
                                              <option value="Purple">Purple</option>
                                              <option value="Orange">Orange</option>
                                              <option value="Kevlar">Kevlar</option>
                                              <option value="Red">Red</option>
                                              <option value="Space">Space</option>
                                              <option value="Yellow">Yellow</option>
                                              <option value="White">White</option>
                                            </select>
                                          </div>
                                      </li>
                                        <li class="nav-item mt-2">
                                            <div class="form-check">
                                                <input v-model="pagination.searchparams.in_stock_only" class="form-check-input" type="checkbox" true-value="true" false-value="" id="flexCheckIndeterminate" @change="search_params_changed = true" :disabled="loading">
                                                <label class="form-check-label" for="flexCheckIndeterminate">
                                                    In Stock Only
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="!product_selected">
                                <div class="order-wrapper" v-if="pagination.data.length > 0">
                                    <div v-if="loading" class="d-flex justify-content-center">
                                        <div class="spinner-border text-success" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                    <div v-else class="order-table px-0 mx-0 my-0" >
                                        <div class="order-tr order-th sticky-top">
                                            <div class="order-td order-img-col"></div>
                                            <div class="order-td order-sku-col">SKU</div>
                                            <div class="order-td order-name-col text-center">Description</div>
                                            <div class="order-td order-price-col">Wholesale</div>
                                            <div class="order-td order-price-col">Retail MAP</div>
                                            <div class="order-td order-quantity-col">QOH</div>
                                            
                                            <!-- <div class="order-td">Quantity</div>
                                            <div class="order-td">Total</div> -->
                                        </div>
                                        <div class="order-tr" v-for="product in products" :key="product.id" :style="product.quantity_orderable > 0 ? 'cursor: pointer;' : 'cursor: pointer;'" @click="setActiveProduct(product)">
                                            
                                            <div class="order-td position-relative order-img-col"><img class="img-thumbnail" :alt="product.name" :src="product.image_url" crossorigin="anonymous" @error="product.image_url='/imgs/doomswell-placeholder.png'"/> 
                                            <span v-if="product.quantity_orderable === 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-danger">
                                                out of stock
                                            </span>
                                            <span v-if="product.quantity_available === 0 && product.quantity_incoming > 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success">
                                                preorder
                                            </span>
                                        </div>
                                            <div class="order-td order-sku-col">{{ product.sku }}</div>
                                            <div class="order-td order-name-col">{{ product.name }}</div> 
                                            <div class="order-td order-price-col fw-bold">{{ product.sale_price | currency }}</div>
                                            <div class="order-td order-price-col">{{ product.retail_price | currency }}</div>
                                            <div class="order-td order-quantity-col">{{ product.quantity_on_hand }}</div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div v-else v-show="!loading" class="row justify-content-center">
                                    <div class="row justify-content-center pt-3 pb-2">
                                      No products matching search criteria found
                                  </div>
                                      
                                  <div class="row justify-content-center col-auto">
                                      <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                                  </div>
                                </div>
                            </div>
                            <div v-else class="row mb-2">
                                <div class="col-12">
                                    <!-- <hr class="mt-3"> -->
                                    <div id="selectedProduct" class="form-select form-select-lg" @click="product_selected = false; cancelOrderItem();" style="cursor: pointer;">{{ selected_product.name }}</div>
                                </div>
                            </div>
                            <!-- </Transition> -->
                                <div v-show="selected_product.length != 0" class="order-item-config">
                                    <div class="row justify-content-start py-2">
                                        <div class="col-auto ">Product Details</div><hr  class="col" style="margin-top:12px;margin-right:12px;">
                                    </div>
                                    <div class="row justify-content-start">
                                        <div class="col-md-2" v-show="selected_product.type">
                                            <label for="selectedProductCategory" class="form-label text-muted mb-0"><small>Category</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductCategory" :value="selected_product.type">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.model">
                                            <label for="selectedProductModel" class="form-label text-muted mb-0"><small>Model</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductModel" :value="selected_product.model">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.size">
                                            <label for="selectedProductSize" class="form-label text-muted mb-0"><small>Size</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductSize" :value="selected_product.size">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.style">
                                            <label for="selectedProductStyle" class="form-label text-muted mb-0"><small>Style</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductStyle" :value="selected_product.style">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.color">
                                            <label for="selectedProductColor" class="form-label text-muted mb-0"><small>Color</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductColor" :value="selected_product.color">
                                        </div>
                                    </div>

                                    <div class="row justify-content-start py-2">
                                        <div class="col-auto ">Order Quantity</div>
                                        <hr  class="col" style="margin-top:12px;margin-right:12px;">
                                    </div>
                                    <div class="row d-flex justify-content-center g-1 px-0 py-2">
                                        <div class="card text-dark " style="background-color:#e3eeff;">
                                            <div class="card-body px-0">
                                                <div class="row d-flex justify-content-evenly">
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Quantity</small></label>
                                                    <input v-model="new_item.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="maxItemQuantity">
                                                </div>
                                                
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductWholesale" class="form-label text-muted mb-0"><small>Wholesale</small></label>
                                                    <input v-if="!new_item.margin_override" type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesale" :value="selected_product.sale_price|currency">
                                                    <input v-else v-model="new_item.unit_price" type="number" step="0.01" class="form-control text-center" id="selectedProductWholesale" :placeholder="selected_product.sale_price|currency">
                                                </div>
                                                <!-- <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductWholesaleMargin" class="form-label text-muted mb-0"><small>Margin</small></label>
                                                    <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesaleMargin" value="45%">
                                                </div> -->
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>MAP</small></label>
                                                    <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductRetail" :value="selected_product.retail_price|currency">
                                                </div>
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="totalCost" class="form-label text-muted mb-0"><small class="fw-bold">Item Total</small></label>
                                                    <input type="text" class="form-control-plaintext text-center fw-bold" id="totalCost" :value="new_item.total_cost|currency">
                                                </div>
                                                <div class="row d-flex justify-content-between align-items-end mt-3">
                                                    <!-- <div class="col-1">
                                                    </div> -->
                                                    <div class="col-md-auto">
                                                        <p  class="text-muted small mb-1">Available: {{ this.selected_product.quantity_available }}</p>
                                                        <p class="text-muted small mb-0">Incoming: {{ this.selected_product.quantity_incoming }}</p>
                                                    </div>
                                                    <div class="col-md-auto">
                                                        <p v-if="!new_item.preorder" class="text-muted text-start small mb-1">
                                                            Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleNewItemPreorder(new_item)"></i>
                                                        </p>
                                                        <p v-else class="text-muted text-start small mb-1">
                                                            Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleNewItemPreorder(new_item)"></i>
                                                        </p>
                                                        <p v-if="!new_item.margin_override" class="text-muted text-end small mb-1"  v-tooltip:bottom="'Set Custom Price'">
                                                            Custom Price &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="new_item.margin_override = !new_item.margin_override"></i>
                                                        </p>
                                                        <p v-else class="text-muted text-end small mb-1"  v-tooltip:bottom="'Restore Default Price (On Save)'">
                                                            Custom Price &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="new_item.margin_override = !new_item.margin_override"></i>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-auto">
                                                        <button class="btn btn-light float-right" type="button" @click="cancelOrderItem">Cancel</button>
                                                        <button :disabled="new_item.total_cost == 0" class="btn btn-primary float-right" type="button" @click="addItemToOrder">Add To Order</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                        </div>
                    </div>


                </div>


                <hr> 
                <div class="row" v-for="(val, key, index) in orderEdit.items">
                
                    <div class="form-group row justify-content-between mb-2" :style="!orderEdit.multi_ship ? 'padding-left:50px;padding-right:90px;' : 'padding-right:50px;'">
                        <div class="col-md-2" style="max-width:100px;">



                            <div class="position-relative order-img-col"><img class="img-thumbnail" :alt="val.name" :src="val.image_url" crossorigin="anonymous" @error="val.image_url='/imgs/doomswell-placeholder.png'"/> 
                                            <span v-if="val.preorder" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success">
                                                preorder
                                            </span>
                                        </div>






                        </div>
                        <div class="col-md-5">
                            <label for="name" class="col-sm-auto col-form-label fw-bold"></label>
                            <div class="col-sm-auto ">
                              <input type="text" readonly class="form-control-plaintext fw-bold text-start" id="name" v-model="val.name">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="sku" class="col-sm-auto col-form-label fw-bold"></label>
                            <div class="col-sm-auto">
                              <input type="text" readonly class="form-control-plaintext fw-bold text-end" id="sku" v-model="val.sku">
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-group row">
                        <div class="row d-flex justify-content-evenly">
                            <div v-if="!orderEdit.multi_ship"class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Quantity</small></label>
                                <input v-model="val.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="val.ship_one.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Ship 1</small></label>
                                <input v-model="val.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="val.ship_one.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                <label for="shipTwoQuantity" class="form-label text-muted mb-0"><small>Ship 2</small></label>
                                <input v-model="val.ship_two.quantity" type="number" class="form-control text-center" id="shipTwoQuantity" name="ship2" min="0" :max="val.ship_two.max_orderable_quantity" @change="recalculateValues(val)">
                            </div>
                            <div v-if="orderEdit.multi_ship" class="col-md-2 text-center"  style="max-width:125px;">
                                <label for="totalQuantity" class="form-label text-muted mb-0"><small>Total Quantity</small></label>
                                <input type="number" readonly class="form-control-plaintext text-center" min="0.01" step="0.01" id="totalQuantity" :value="val.total_quantity" >
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductWholesale" class="form-label text-muted mb-0"><small>Wholesale</small></label>
                                <input v-if="!val.margin_override" type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesale" :value="val.unit_price|currency">
                                <input v-else v-model="val.unit_price" type="number" step="0.01" class="form-control text-center" id="selectedProductWholesale" @change="recalculateValues(val)">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductWholesaleMargin" class="form-label text-muted mb-0"><small>Margin</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center" :class="val.margin_override ? 'text-decoration-line-through text-muted' : ''" id="selectedProductWholesaleMargin" :value="marginDiscount">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>MAP</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductRetail" :value="val.retail_price|currency">
                            </div>
                            <div class="col-md-2 text-center" style="max-width:100px;">
                                <label for="totalCost" class="form-label text-muted mb-0"><small class="fw-bold">Item Total</small></label>
                                <input type="text" readonly class="form-control-plaintext text-center fw-bold" id="totalCost" :value="val.total_cost|currency">
                            </div>
                            <div class="row d-flex justify-content-between align-items-end mt-3">
          
                                <div class="col-md-auto" :class="orderEdit.multi_ship ? '' : 'offset-sm-1 px-1 mx-5'">
                                    <p  class="text-muted small mb-1" v-if="val.quantities">Available: {{ val.quantities.quantity_available }}</p>
                                    <p class="text-muted small mb-0" v-if="val.quantities">Incoming: {{ val.quantities.quantity_incoming }}</p>
                                    <p class="text-muted small mb-0" v-else>Save draft to see quantities</p>
                                </div>
                                 <div class="col-md-auto">
                                    <p v-if="!val.margin_override" class="text-muted text-end mb-1"  v-tooltip:bottom="'Set Custom Price'">
                                        Ignore Margin &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="val.margin_override = !val.margin_override"></i>
                                    </p>
                                    <p v-else class="text-muted text-end mb-1"  v-tooltip:bottom="'Restore Default Price (On Save)'">
                                        Ignore Margin &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="val.margin_override = !val.margin_override"></i>
                                    </p>
                                </div>
                                <div class="col-md-auto">
                                    <p v-if="!val.preorder" class="text-muted text-end mb-1">
                                        Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="togglePreorder(val)" @change="order_values_changed = true"></i>
                                    </p>
                                    <p v-else class="text-muted text-end mb-1">
                                        Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="togglePreorder(val)" @change="order_values_changed = true"></i>
                                    </p>
                                    <p class="text-muted text-end mb-0">
                                        Remove Item &nbsp <i type="button" role="button" class="fa fa-trash text-danger" aria-hidden="true" @click="deleteItem(val.id)"></i>
                                    </p>
                                </div>
                           
                            </div>
                        </div>
                    </div>
                    <hr v-if="key !== lastItem" class="mt-3" >
                </div>


                <!-- <div class="row justify-content-center" v-if="!loading">
                    <div class="col-md-12">
                        <div class="card mb-2" >
                            <div class="card-header">
                                <span class="lead">Order Details</span>
                            </div>
                            <div class="card-body" style="font-size:.9rem;">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-auto col-form-label fw-bold" for="contactName">Buyer:</label>
                                            <div class="col-sm-auto">
                                                <span id="contactName" class="form-control-plaintext">{{ orderContact.contact_name }}</span>
                                                <span id="company_name" class="form-control-plaintext">{{ orderContact.company_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Email:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.email }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Phone:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderCity">City:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.city }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderState">State:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.state }}</span>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Rep:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ user.name }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Order Date:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ todaysDate }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->




              <!-- {{ orders }} -->
              <!-- <table class="table table-condensed table-hover" style="display:table">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" style="white-space:nowrap;">PO#</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Ordered</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Received</th>
                    <th scope="col" style="white-space:nowrap;">Arrival Due Date</th>
                  </tr> 
                </thead>
                <tbody>
                  <tr v-for="order in orders">
                    <td>{{ order.po_number }}</td>
                    <td class="text-center">{{ order.quantity_ordered }}</td>
                    <td class="text-center">{{ order.quantity_received }}</td>
                    <td>{{ order.arrival_date | moment }}</td>
                  </tr>
                  <tr>
                    <td><strong>Total</strong></td>
                    <td class="text-center"><strong>{{ totalOrdered }}</strong></td>
                    <td class="text-center"><strong>{{ totalReceived }}</strong></td>
                    <td><span v-if="totalReceived != 0"><strong>Incoming: {{ totalOrdered - totalReceived }}</strong></span></td>
                  </tr>
                </tbody>
              </table>    -->
            </div>
            <!-- Modal Actions -->
            <div class="modal-footer border-none">

                <button type="button" class="btn btn-light" @click="closeModal">
                    <span v-if="order_values_changed">Cancel</span>
                    <span v-else>Close</span>
                </button>
                <button v-if="order_values_changed" type="button" class="btn btn-light text-white" style="background-color:#ff7a59;"  @click="updateOrder">Save</button>
              
            </div>
          </div>
        </div>
      </div>

      <!-- end of modal -->
  </div>
</template>

<style lang="css" scoped>
.v-enter-active,
    .v-leave-active {
      transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
      opacity: 0;
    }

    .btn-light {
    background-color: white;
    /*border-color: #49545a;*/
    border: 1px solid #b0b9bf;
  }

  .btn-light:hover, .btn-light:active, .btn-light:focus {
    background-color: #dde1e3;
  }

    .btn-search {
        border-radius: 0rem .25rem .25rem 0rem;
      }

      .btn-reset {
        border-top-left-radius: 0.375rem;
      }

    .order-item-config {
        font-size: 1rem;
    }
    .card-header {
        background-color:  #fff;
    }

    .order-wrapper {
        border: var(--bs-card-border-width) solid var(--bs-card-border-color);
        border-radius: var(--bs-card-border-radius);
        font-size: .75rem;
        width: 100%;
        max-height:275px;
        overflow-x:auto;
        overflow-y:scroll;
    }

     /*@media (min-width: 1400) {
        .order-wrapper {
          overflow-x: hidden;
        }
      }*/


    .order-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 1.5;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .order-table > .order-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .order-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .order-th > .order-td {
        white-space: normal;
    }

      .order-tr {
        min-width: 728px;
        display: flex;
        flex-flow: row nowrap;

    }

    

     .order-tr:nth-of-type(even) {
        background-color: #f8fafc;
    }

    .order-tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .order-tr:hover {
        background-color: #f2f2f2;
    }

    .order-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        border-bottom: 1px solid #d0d0d0;
        align-items: center;
    }

    .order-img-col {
        min-width: 100px;
        justify-content: center;
    }

    .order-sku-col {
        min-width: 183px;
        justify-content: center;
    }

    .order-name-col {
        min-width: 175px;
        justify-content: center;
        text-align: center;
    }

    .order-price-col {
        min-width: 100px;
        justify-content: center;
    }

    .order-quantity-col {
        min-width: 70px;
        justify-content: center;
    }
</style>

<script>
    const qs = require('qs');
    import moment from 'moment'

    export default {
    // props:['order'],
    props:{
        onSaveCallback: {
        type: Function,
        default: function () {return true;}
      },
      order: {
        type: [Array, Object]
      }
    },
    data() {
      return {
        order_endpoint: "/api/orders/order/",
        orderEdit: [],
        errors: [],
        products: [],
        showing_modal: false,
        min_ship_date: null,
        max_ship_date: null,
        updating: false,
        loading: true,
        fetched_order_items: false,
        order_values_changed: false,
        add_item: false,
        fetched_products: false,
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 1000,
          "contacts": [],
          "searchparams": {
            "search": "",
            "sortby": "sku",
            "order": "asc",
            "type": "",
            "style": "",
            "model": "",
            "color": "",
            "size": "",
            "in_stock_only": true
          },
        },
        product_endpoint: "/api/orders/products",
        search_params_changed: false,
        product_selected: false,
        selected_product: [],
        // refreshHack: 0,
        new_item: {
            "id": null,
            "sku": null,
            "name": null,
            "image_url": null,
            "preorder": false,
            "margin_override": false,
            "unit_price": 0,
            "total_quantity": 0,
            "total_cost": 0,
            "ship_one": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            },
            "ship_two": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            }
        },
      };
    },
    created() {
      // runs when the component is created
      // this.alias();
      Bus.$on('editShipstationOrderModalShow', () => {
        this.orderEdit = structuredClone(this.order);
        this.fetchOrderItems();
        this.setDefaults();
        this.showModal();
        // this.test();
      });
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
      lastItem(){
         return Object.keys(this.orderEdit.items).length-1;
      },
      // sum: function(items, prop){
      //   return items.reduce( function(a, b){
      //     return a + b[prop];
      //   }, 0);
      // },
      // orderedSum(){
      //   return this.sum(this.orders,'quantity_ordered');
      // },
      marginDiscount(){
        if (this.orderEdit.discount_percent == 0)
        {
            return '45%';
        } else {
            return this.orderEdit.discount_percent + '%';
        }
      },
      maxItemQuantity(){
            if (this.selected_product.length != 0 && !this.new_item.preorder)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available;
            } else if (this.selected_product.length != 0 && this.new_item.preorder) {
                return null;
            } else {
                return 0;
            }
        },
        newItemTotals(){
                
                this.new_item.ship_one.cost = this.new_item.ship_one.quantity * this.new_item.unit_price;
                this.new_item.ship_two.cost = this.new_item.ship_two.quantity * this.new_item.unit_price;
                this.new_item.total_quantity = +this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity;
                this.new_item.total_cost = (this.new_item.ship_one.quantity * this.new_item.unit_price) + (this.new_item.ship_two.quantity * this.new_item.unit_price);
                // this.refreshHack;
                if (this.selected_product.quantity_available == 0 && this.selected_product.quantity_incoming > 0)
                {
                    this.new_item.preorder = true;
                }
                
        },
        newItemTotalQuantity(){
            return +this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity;
        },
    },
    methods: {
      //   test(){
      //    Swal.fire('Test!', 'Hello test message','success');
      // },
        deleteItem(item_id){
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item_id));

          let self = this;
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove this item'
          }).then((result) => {
            if (result.value) {
              axios
                .delete('/api/orders/order/' + item_id)
                .then((res) => {
                  Swal.fire(
                    'Deleted!',
                    'The item has been removed.',
                    'success'
                  );
                  this.orderEdit.items.splice( objIndex, 1 );
                  this.recalculateValues(this.orderEdit.items[0]);
                  this.successfulSave();
                  // Bus.$emit('editOrderItems(orderEdit.id)');
                }).catch((error) => {
                  console.log(error);
                  // Bus.$emit('newOacAlert', {text: "Could not remove order", type: 'danger'});
                }).finally(() => {
                    this.updateOrder();
                });
            }
          });
        },
        togglePreorder(item){
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item.id));

            this.orderEdit.items[objIndex].preorder = !this.orderEdit.items[objIndex].preorder;

            if(this.orderEdit.items[objIndex].preorder === true)
            {
                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = null;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = null;
            } else {
                if ((this.orderEdit.items[objIndex].ship_one.quantity + this.orderEdit.items[objIndex].ship_two.quantity) > this.orderEdit.items[objIndex].quantities.quantity_orderable)
                {
                    this.orderEdit.items[objIndex].ship_one.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable;

                    this.orderEdit.items[objIndex].ship_two.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;
                    this.orderEdit.items[objIndex].total_quantity = +this.orderEdit.items[objIndex].ship_one.quantity + +this.orderEdit.items[objIndex].ship_two.quantity;
                }

                // if (this.orderEdit.items[objIndex].ship_two.quantity > (this.orderEdit.items[objIndex].quantities.quantity_orderable + this.orderEdit.items[objIndex].ship_one.quantity))
                // {
                    
                // }

                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_two.quantity;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;

                this.recalculateValues(this.orderEdit.items[objIndex]);
            }
        },
        recalculateValues(item){
            this.order_values_changed = true;
            // console.log(item);
            let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item.id));
            
            // console.log("Before update: ", this.orderEdit.items[objIndex])
            // let id = item.id
            // console.log("Before update: ", this.orderEdit.items);//this.orderEdit.items[id]);
            this.orderEdit.items[objIndex].total_quantity = +item.ship_one.quantity + +item.ship_two.quantity;
            this.orderEdit.items[objIndex].total_cost = (item.ship_one.quantity * item.unit_price) + (item.ship_two.quantity * item.unit_price);
            this.orderEdit.items[objIndex].ship_one.cost = item.ship_one.quantity * item.unit_price;
            this.orderEdit.items[objIndex].ship_two.cost = item.ship_two.quantity * item.unit_price;
            
            if(typeof this.orderEdit.items[objIndex].quantities !== 'undefined' && !this.orderEdit.items[objIndex].preorder )
            {
                this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = item.quantities.quantity_orderable - item.ship_two.quantity;
                this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = item.quantities.quantity_orderable - item.ship_one.quantity;

            }
            
           

            let total = 0;
                this.orderEdit.items.forEach((item) => {
                    total = +item.total_cost + total;
                });

                this.orderEdit.total_cost = +(Math.round(total + "e+2")  + "e-2");
        },
        setDefaults(){
            this.min_ship_date = moment().add(1, 'd').format("YYYY-MM-DD");
            this.max_ship_date = moment().add(1, 'Y').format("YYYY-MM-DD");
        },
        toggleSplitShipments(){
            this.orderEdit.multi_ship = !this.orderEdit.multi_ship;

            if (!this.orderEdit.multi_ship)
            {
                this.orderEdit.ship_two_date = null;
                this.orderEdit.items.forEach((item) => {
                    item.ship_one.quantity = +item.ship_one.quantity + +item.ship_two.quantity;
                    item.ship_two.quantity = 0;
                    item.ship_two.cost = 0;
                    item.ship_two.preorder = false;
                });
            } else {
                if (this.orderEdit.ship_two_date === null)
                {
                    this.orderEdit.ship_two_date = moment().add(1, 'M').format("YYYY-MM-DD");
                }
            }
        },
      closeModal(){
        $('#modal-edit-shipstation-order').modal('hide');
        // Bus.$emit('updateOrderItems');
        this.order_values_changed = false;
        this.showing_modal = false;
        this.resetSearch();
        this.cancelOrderItem();
      },
      showModal(){
        $('#modal-edit-shipstation-order').modal('show');
        this.showing_modal = true;
      },
      updateOrder(){
        this.orderEdit.shipstation_status = 'Update Queued';
        this.orderEdit.hubspot_status = 'Shipstation Update Queued';
        this.updating = true;
        axios({
          method: 'put',
          url: '/api/orders/order/' + this.orderEdit.id,
          data: this.orderEdit,
        }).then((res)=>{
            this.successfulSave();
            this.updating = false;
            this.closeModal();
            // this.saved = true;
            // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
        }).catch((error) => {
          console.log(error);
          // this.errors.push({msg: error.response.data.message });
          // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
        });
    },
      successfulSave(){
        this.onSaveCallback();
      },
      fetchOrderItems() {
        // this.loading = true;
        axios.get(this.order_endpoint + this.orderEdit.id)
        .then((res) => {
            this.orderEdit = res.data;
            // this.orderEdit.push({items: res.data.items });
            // this.orderEditItems = res.data.items;
            // this.products = res.data.data;
            // this.contacts = res.data.contacts;
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            this.fetched_order_items = true;
            this.loading = false;
            return true;
          });
      },
      addItemToggle() {
        if (this.add_item === false) {
            this.add_item = true;
        } else {
            this.add_item = false;
        }

        if (this.fetched_products === false)
        {
            this.fetchProducts(this.pagination.searchparams);
        } else {
            this.resetSearch();
            this.cancelOrderItem();
        }
      },
      fetchProducts(params, page = 1) {
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.product_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.products = res.data.data;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_products = true;
            return true;
          });
      },
      nextPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchProducts(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchProducts(this.pagination.searchparams);
        this.search_params_changed = false;
      },
        resetSearch()
        {
            this.pagination.first_page_url = null;
            this.pagination.from = null;
            this.pagination.last_page = null;
            this.pagination.last_page_url = null;
            this.pagination.next_page_url = null;
            this.pagination.path = null;
            this.pagination.prev_page_url = null;
            this.pagination.to = null;
            this.pagination.total = null;
            this.pagination.has_more_pages = false;
            this.pagination.per_page = 1000;
            this.pagination.searchparams.search = '';
            this.pagination.searchparams.sortby = 'sku';
            this.pagination.searchparams.order = 'asc';
            this.pagination.searchparams.type = '';
            this.pagination.searchparams.style = '';
            this.pagination.searchparams.model = '';
            this.pagination.searchparams.color = '';
            this.pagination.searchparams.size = '';
            this.pagination.searchparams.in_stock_only = true;
            this.runSearch();
        },
        cancelOrderItem(){
            this.product_selected = false;
            this.selected_product = [];
            this.resetOrderItem();
        },
        resetOrderItem(){
            this.new_item.id = null;
            this.new_item.sku = null;
            this.new_item.name = null;
            this.new_item.image_url = null;
            this.new_item.unit_price = 0;
            this.new_item.total_cost = 0;
            this.new_item.preorder = false;
            this.new_item.ship_one.quantity = 0;
            this.new_item.ship_one.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.ship_two.quantity = 0;
            this.new_item.ship_two.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.margin_override = false;
        },
        addItemToOrder(){
            const line_item = structuredClone(this.new_item);

            if (line_item.preorder == true)
            {
                this.new_order.contains_preorder = true;
            }

            this.orderEdit.items.push(line_item);
            this.cancelOrderItem();
            this.add_item = false;

            this.recalculateValues(this.orderEdit.items[this.lastItem]);
        },
        setActiveProduct(product) {

            // if (product.quantity_orderable != 0)
            // {
            //     this.new_item.preorder = true;
            // }
                if (this.selected_product.length != 0)
                {
                    this.resetOrderItem();
                }

                this.selected_product = product;
                this.product_selected = true;
                this.new_item.id = product.id;
                this.new_item.sku = product.sku;
                this.new_item.image_url = product.image_url;
                this.new_item.name = product.name;
                this.new_item.unit_price = product.sale_price;
                // this.refreshHack++;
            
        },
        toggleNewItemPreorder(item){

            this.new_item.preorder = !this.new_item.preorder;

            if(!this.new_item.preorder)
            {
                if ((+this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity) > (+this.selected_product.quantity_available + +this.selected_product.quantity_incoming))
                {
                    this.new_item.ship_one.quantity = +this.selected_product.quantity_available + +this.selected_product.quantity_incoming;
                    this.new_item.ship_two.quantity = 0;
                }
                
            }
            //     this.maxShipOneItemQuantity = null;
            //     this.maxShipTwoItemQuantity = null;
            // } 
            // else {
                // if ((this.orderEdit.items[objIndex].ship_one.quantity + this.orderEdit.items[objIndex].ship_two.quantity) > this.product.quantity_orderable)
                // {
                //     this.orderEdit.items[objIndex].ship_one.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable;

                //     this.orderEdit.items[objIndex].ship_two.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;
                //     this.orderEdit.items[objIndex].total_quantity = +this.orderEdit.items[objIndex].ship_one.quantity + +this.orderEdit.items[objIndex].ship_two.quantity;
                // }

                // // if (this.orderEdit.items[objIndex].ship_two.quantity > (this.orderEdit.items[objIndex].quantities.quantity_orderable + this.orderEdit.items[objIndex].ship_one.quantity))
                // // {
                    
                // // }

                // this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_two.quantity;
                // this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;


            // }
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
    watch:{
       orderEdit(val) {
           this.orderEdit.closed_at = this.$options.filters.moment(val);
           // this.orderEdit.total_cost = this.$options.filters.currency(val);
        },
        newItemTotalQuantity: function (val) {
            this.new_item.total_cost = val * this.new_item.unit_price;
            this.new_item.total_quantity = val;
        },
    }
  }
  // Bus.$emit('updateUser');
</script>